import { apiClient, getAuthToken } from "./client";

export async function listDeveloperUsers() {
  const { data } = await apiClient.get("/dev/users");
  return data;
}

export async function createDeveloperUser(payload) {
  const { data } = await apiClient.post("/dev/users", payload);
  return data;
}

export async function updateDeveloperUser(email, payload) {
  const { data } = await apiClient.patch(`/dev/users/${encodeURIComponent(email)}`, payload);
  return data;
}

export async function deleteDeveloperUser(email) {
  const { data } = await apiClient.delete(`/dev/users/${encodeURIComponent(email)}`);
  return data;
}

export async function getDeveloperUserOrgAccess(email) {
  const { data } = await apiClient.get(`/dev/users/${encodeURIComponent(email)}/org-access`);
  return data;
}

export async function setDeveloperUserOrgAccess(email, orgId, accessStatus) {
  const { data } = await apiClient.put(
    `/dev/users/${encodeURIComponent(email)}/org-access/${orgId}`,
    { access_status: accessStatus },
  );
  return data;
}

export async function getOrgMembers(orgId) {
  const { data } = await apiClient.get(`/dev/orgs/${encodeURIComponent(orgId)}/members`);
  return data;
}

export async function listPendingOrgRequests() {
  const { data } = await apiClient.get("/dev/org-requests/pending");
  return data;
}

export async function decideOrgRequest(requestId, decision) {
  const { data } = await apiClient.post("/dev/org-requests/decision", {
    request_id: requestId,
    decision,
  });
  return data;
}

export async function getDeveloperAuthMethods() {
  const { data } = await apiClient.get("/dev/auth-methods");
  return data;
}

export async function updateDeveloperAuthMethods(payload) {
  const { data } = await apiClient.put("/dev/auth-methods", payload);
  return data;
}

export async function listClientManagerSummary() {
  const { data } = await apiClient.get("/dev/client-managers-summary");
  return data;
}

export async function listDeveloperTrials() {
  const { data } = await apiClient.get("/dev/trials");
  return data;
}

export async function updateDeveloperTrialAutoBlock(orgId, autoBlockDisabled) {
  const { data } = await apiClient.put(`/dev/trials/${encodeURIComponent(orgId)}/auto-block`, {
    auto_block_disabled: Boolean(autoBlockDisabled),
  });
  return data;
}

export async function getDeveloperTrialOrg() {
  const { data } = await apiClient.get("/dev/trial-org");
  return data;
}

export async function setDeveloperTrialOrg(trialOrgId) {
  const { data } = await apiClient.put("/dev/trial-org", {
    trial_org_id: trialOrgId || null,
  });
  return data;
}

export function openDeveloperWebSocket(onMessage, onError) {
  const token = getAuthToken();
  if (!token) {
    return null;
  }

  const baseUrl = (apiClient.defaults.baseURL || "http://127.0.0.1:8000").replace(/\/$/, "");
  const wsBase = baseUrl.replace(/^http:/i, "ws:").replace(/^https:/i, "wss:");
  const ws = new WebSocket(`${wsBase}/dev/ws?token=${encodeURIComponent(token)}`);

  ws.onmessage = (event) => {
    try {
      const parsed = JSON.parse(event.data);
      // normalize message shape so callers can always expect { event, at, payload }
      const message = {
        event: parsed?.event || "message",
        at: parsed?.at || new Date().toISOString(),
        payload: parsed?.payload !== undefined ? parsed.payload : parsed,
      };
      onMessage?.(message);
    } catch {
      // no-op
    }
  };

  ws.onerror = (event) => {
    onError?.(event);
  };

  const heartbeat = setInterval(() => {
    if (ws.readyState === WebSocket.OPEN) {
      ws.send("ping");
    }
  }, 25000);

  ws.onclose = () => {
    clearInterval(heartbeat);
  };

  return ws;
}
